export default __webpack_public_path__ + "static/AppCV5-6feb8dfc171e57242d147035ce362ce5.png";